import { useSite } from "../context/SiteContext";

export default function Footer() {
    const { site, tx } = useSite();
    const s = site?.settings || {};
    return (
        <footer data-testid="site-footer" className="relative bg-[#0A0A0A] text-white border-t border-white/10 overflow-hidden">
            <div className="px-6 md:px-12 lg:px-24 pt-20">
                <div className="font-display leading-[0.8] text-[13vw] whitespace-nowrap text-white/10 select-none" aria-hidden="true">
                    BEYOND THE FIELD<span className="text-[#D60024]/40">+</span>
                </div>
                <div className="mt-12 pb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
                    <p className="text-xs tracking-[0.25em] uppercase text-white/50" data-testid="footer-text">
                        © {new Date().getFullYear()} Beyond The Field+ — {tx(s.footer_text)}
                    </p>
                    <div className="flex items-center gap-6 text-[11px] font-semibold tracking-[0.2em] uppercase">
                        {s.instagram && <a data-testid="footer-instagram" href={s.instagram} target="_blank" rel="noopener noreferrer" className="u-line text-white/70 hover:text-white">Instagram</a>}
                        {s.linkedin && <a data-testid="footer-linkedin" href={s.linkedin} target="_blank" rel="noopener noreferrer" className="u-line text-white/70 hover:text-white">LinkedIn</a>}
                        <a data-testid="footer-admin-link" href="/admin/login" className="u-line text-white/40 hover:text-[#D60024]">Admin</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
